function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0a0a0a;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "12Artboard 1");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0,215.06.39,292a11,11,0,0,0,11,11H27.88a68.28,68.28,0,1,0,134,0H301.81A68.25,68.25,0,0,0,424,356.3a68.2,68.2,0,0,0,58.3,28c36.61-1.65,65.13-32.5,65.13-69.15V286.07A26.07,26.07,0,0,0,521.32,260H178.39L178,130.86a20.43,20.43,0,0,0-20.43-20.36H104.62a59,59,0,0,0-42,17.7l-47,48.17A55,55,0,0,0,0,215.06ZM451.23,318.68a28,28,0,1,1,25.6,25.61A28,28,0,0,1,451.23,318.68Zm-110.29,0a28,28,0,1,1,25.61,25.61A28,28,0,0,1,340.94,318.68Zm-273.61,0a28,28,0,1,1,25.61,25.61A28,28,0,0,1,67.33,318.68ZM57.39,193l34.94-35.82A17.21,17.21,0,0,1,104.62,152h31.77v40.61Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M206.39,28.25v176.5A28.25,28.25,0,0,0,234.64,233h285.5a28.25,28.25,0,0,0,28.25-28.25V28.25A28.25,28.25,0,0,0,520.14,0H234.64A28.25,28.25,0,0,0,206.39,28.25Zm31,2.75h280V202h-280Z"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 458.7,
  y: 55.65,
  width: 25.24,
  height: 118.88,
  rx: 3.07
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 396.66,
  y: 55.65,
  width: 25.24,
  height: 118.88,
  rx: 3.07
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 334.62,
  y: 55.65,
  width: 25.24,
  height: 118.88,
  rx: 3.07
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 272.59,
  y: 55.65,
  width: 25.24,
  height: 118.88,
  rx: 3.07
});

var SvgTruckExportEmpty = function SvgTruckExportEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 548.39 384.38",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTruckExportEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/truck-export-empty.a367e0be.svg";
export { ForwardRef as ReactComponent };